import {Injectable, OnDestroy} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EMPTY, interval} from 'rxjs/index';
import {map} from 'rxjs/internal/operators';

@Injectable({
  providedIn: 'root'
})
export class PingService implements OnDestroy {

  private readonly PORTAL_PING_URL = '/portal/wlxapp/Ping.srv';
  private intervalSubscribe;

  constructor(private http: HttpClient) {
  }

  public initialisePingInterval(repeatPingCount: number, intervalPeriod: number) {
    this.clearInterval();
    this.intervalSubscribe = interval(intervalPeriod).subscribe(() => {
      repeatPingCount > 0 ? this.ping() : this.clearInterval();
      repeatPingCount--;
    });
  }

  private ping() {
    this.pingPortal();
  }

  private clearInterval() {
    if (!this.intervalSubscribe) {
      return;
    }
    this.intervalSubscribe.unsubscribe();
  }

  private pingPortal() {
    this.http.post(this.PORTAL_PING_URL, {})
      .pipe(
        map((response: Response) => response.text())
      )
      .subscribe(response => EMPTY, error => EMPTY);
  }

  ngOnDestroy(): void {
    this.clearInterval();
  }
}
